// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import ResourceLinkDTO from '../../dto/resource/ResourceLinkDTO';

export default abstract class ResourceLinkModel extends BaseModel<ResourceLinkDTO> {
  /**
  */
  get href() { return this.dto.href; }
  /**
  */
  get rel() { return this.dto.rel; }
  /**
  */
  get method() { return this.dto.method; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
  }
}
